import React from 'react';

import { Box } from '@atlaskit/primitives';

import { ChangedValueStyles } from './styles';

type Props = {
  value: string;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const ChartValue: React.FC<Props> = ({ value }) => {
  return <Box xcss={ChangedValueStyles}>{value}</Box>;
};
